export default __webpack_public_path__ + "static/media/storageUnit1-afterD-768w.66ade19e.png";